import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LessonViewSidePanelStore } from './typings';

const initialState: LessonViewSidePanelStore = {
    isExpanded: true,
};

const slice = createSlice({
    name: 'LESSON_VIEW_SIDE_PANEL',
    initialState: initialState,
    reducers: {
        setExpanded: (state: LessonViewSidePanelStore, action: PayloadAction<boolean>) => {
            state.isExpanded = action.payload;
        },
    },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
